import SettingsContext from "../SettingsContextIde";
import { useContext } from "react";

const useSettingsAdmin = () => useContext(SettingsContext);

export default useSettingsAdmin;  
